module.exports = __webpack_public_path__ + "static/media/serviceQualityNewKtm.2ac6ab28.svg";